import React from 'react';
import DiscordIcon from '../icons/DiscordIcon'

import '../../css/discord-join-button.css'

function DiscordJoinButton(props){
  return (
    <>
			{props.size === 'large' &&
				<div
					className='discord-join-button'
					style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}
					onClick={() => { window.open(props.shareLink, "_blank"); }}
				>
					<span style={{ flexShrink: 0 }}>
						<DiscordIcon size={props.iconSize} theme='light'></DiscordIcon>
					</span>
					<span style={{ whiteSpace: 'nowrap' }}>Join Discord</span>
				</div>
			}
			{props.size === 'small' &&
				<div
					className='discord-join-button-small'
					style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}
					onClick={() => { window.open(props.shareLink, "_blank"); }}
				>
					<span style={{ flexShrink: 0 }}>
						<DiscordIcon size={props.iconSize} theme='light'></DiscordIcon>
					</span>
					<span style={{ whiteSpace: 'nowrap' }}>Join Discord</span>
				</div>
			}
    </>
  );
};

DiscordJoinButton.defaultProps = {
	channelName: 'CryptoWaves',
	shareLink: 'https://discord.gg/7ZDUktAv',
	size: 'large',
	iconSize: 20
};

export default DiscordJoinButton;
